import React from 'react';
import Chatbot1 from './Components/intialChatbot.js';  // Import the Chatbot1 component

function App() {
  return (
      <Chatbot1/>
  );
}

export default App;
